module.exports = __webpack_public_path__ + "static/img/groundabout9.75e4afa7.png";